var Backbone, SupportCurrentOrderView, SupportDealSummaryView, SupportExternalDealNotesView, SupportOrderActionsView, SupportOrderSummaryView, SupportServiceActionMainView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportDealSummaryView = require('./deal_summary_view');

SupportOrderSummaryView = require('./order_summary_view');

SupportOrderActionsView = require('./order_actions_view');

SupportServiceActionMainView = require('./service_action_main_view');

SupportExternalDealNotesView = require('./external_deal_notes');

Backbone = require('backbone');

Backbone.$ = $;

SupportCurrentOrderView = (function(superClass) {
  extend(SupportCurrentOrderView, superClass);

  function SupportCurrentOrderView() {
    return SupportCurrentOrderView.__super__.constructor.apply(this, arguments);
  }

  SupportCurrentOrderView.prototype.className = 'row order-details';

  SupportCurrentOrderView.prototype.initialize = function(options) {
    this.I18nScope = 'modules.support';
    this.currentOrder = Groupon.Support.currentOrder;
    return this.options = options || {};
  };

  SupportCurrentOrderView.prototype.renderSubViews = function() {
    this.renderExternalDealNotes();
    this.renderDealSummary();
    this.renderOrderSummary();
    return this.renderOrderActions();
  };

  SupportCurrentOrderView.prototype.render = function() {
    this.renderSubViews();
    return this.layoutView();
  };

  SupportCurrentOrderView.prototype.layoutView = function() {
    this.dealSummary.$el.addClass('five columns');
    $('.deal-image', this.dealSummary.$el).addClass('five columns');
    $('.deal-info', this.dealSummary.$el).addClass('seven columns');
    this.orderSummary.$el.addClass('seven columns');
    if (!this.options.hideSelfServiceActions) {
      this.serviceActionMain.$el.addClass('cb');
      this.orderSummary.$el.append(this.serviceActionMain.el);
    }
    this.$el.append(this.dealSummary.el);
    return this.$el.append(this.orderSummary.el);
  };

  SupportCurrentOrderView.prototype.renderDealSummary = function() {
    this.createDealSummaryView();
    return this.dealSummary.render();
  };

  SupportCurrentOrderView.prototype.renderOrderSummary = function() {
    this.createOrderSummaryView();
    return this.orderSummary.render();
  };

  SupportCurrentOrderView.prototype.renderOrderActions = function() {
    this.createServiceActionView();
    if (!this.options.hideSelfServiceActions) {
      return this.serviceActionMain.render();
    }
  };

  SupportCurrentOrderView.prototype.renderExternalDealNotes = function(contentWrapper) {
    this.externalDealNotes = new SupportExternalDealNotesView();
    if (!this.options.hideExternalDealNotes && this.externalDealNotes.externalDealNotesPresent()) {
      this.externalDealNotes.render();
      return this.$el.append(this.externalDealNotes.el);
    }
  };

  SupportCurrentOrderView.prototype.createDealSummaryView = function() {
    return this.dealSummary = new SupportDealSummaryView();
  };

  SupportCurrentOrderView.prototype.createOrderSummaryView = function() {
    return this.orderSummary = new SupportOrderSummaryView();
  };

  SupportCurrentOrderView.prototype.createServiceActionView = function() {
    return this.serviceActionMain = new SupportServiceActionMainView({});
  };

  return SupportCurrentOrderView;

})(Backbone.View);

module.exports = SupportCurrentOrderView;

//# sourceMappingURL=data:application/json;base64,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
